import { ICloseSaleIn } from "../../models/input/agendaApi/ICloseSaleIn";
import * as ApiWithToken from "../callApiWithToken";


const closingSalesService = {
    getCheckInQuantity:async function(posCode:string){
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `Sale/GetCheckInQuantity?posCode=${posCode}`);
    },
    insertClosingSale:async function(closeSaleInsertIn: ICloseSaleIn[]){
        return ApiWithToken.postApi(process.env.REACT_APP_AGENDAS_API + `Sale/InsertClosingSale`, closeSaleInsertIn);
    },
    GetPosSales:async function(flag:number,date:string,posCode:string){
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `Sale/GetPosSales?flag=${flag}&date=${date}&posCode=${posCode}`);
    },
    GetPosSalesHistory:async function(posCode:string, brandId:number, languageId:number, date:string){
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `Sale/GetPosSalesHistory?posCode=${posCode}&brandID=${brandId}&LanguageID=${languageId}&date=${date}`);
    },
}
export default closingSalesService;
